// Match Maker quotes name a supplier and a master product since the products table was frozen
// (2026-10-22). These read the master product and the supplier's live price off the API shapes.
import type { QuotationSupplierProduct, RestaurantInquiryQuote, SupplierPriceSummary } from 'apis/restaurant-inquiries';

/** The supplier's live price for a quotable master product, if it prices it. */
export const supplierPriceOf = (product: QuotationSupplierProduct | null | undefined): SupplierPriceSummary | null =>
  product?.supplierPrices?.[0] ?? null;

/** The master product a quote names (older quotes: the one their products row was linked to). */
export const quoteMasterProductId = (
  quote: Pick<RestaurantInquiryQuote, 'masterProductId' | 'product'>
): number | null => quote.masterProductId ?? quote.product?.masterProduct?.id ?? null;

/** What a quote offers, for labels: the product name, else the master product's family, else its id. */
export const quoteProductLabel = (
  quote: Pick<RestaurantInquiryQuote, 'masterProductId' | 'productId' | 'product' | 'masterProduct'>
): string => {
  const name = quote.product?.nameEn || quote.masterProduct?.family?.universalName;
  if (name) return name;
  const masterProductId = quoteMasterProductId(quote);
  if (masterProductId != null) return `Master product #${masterProductId}`;
  return quote.productId != null ? `SKU #${quote.productId}` : 'Unknown product';
};
